import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
// import "./../../Products/Faq/Faq.css";
import AskFaq from "./../../../../Images/askFaq.png";
function FnOFaq() {
  return (
    <>
      <section className="faq-block">
        <Container>
          <Row>
            <Col md={8}>
              <h1>Frequently Asked Questions</h1>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Q1. What are derivatives?</Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      A derivative contract is a financial contract that derives
                      its value from an underlying asset or group of assets. A
                      derivative contract is an agreement between two or more
                      parties that can be traded on an exchange or
                      over-the-counter market. Bonds, stocks, commodities,
                      currencies, interest rates, and so on are some of the most
                      common underlying assets for derivatives. Derivatives
                      prices are determined by the movement in prices of the
                      underlying asset. Derivatives can be used to manage risk,
                      speculate on the direction of an underlying asset, or
                      provide leverage to holdings.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Q2. What are futures?</Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      Futures are exchange-traded derivative contracts with
                      standardised contract specifications. A futures contract
                      is an agreement between two participants to buy or sell
                      the underlying asset at a pre-determined price on a
                      specific date. A stock, index, currency, or commodity can
                      serve as the underlying asset. The contract is directly
                      executed via a regulated and organized exchange and the
                      parties of the futures contract are obligated to carry out
                      the terms of the agreement. Futures are primarily used to
                      hedge commodity price volatility or to profit from price
                      movements, as opposed to buying or selling the actual cash
                      commodity, as is done with stocks. Every day, the value of
                      future contracts is marked to market. That is, the
                      contract value is adjusted based on market movements until
                      the expiration date.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>Q3. How can I trade in the F&O segment using Moneysukh?</Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <ul>
                      <li>Visit trade.moneysukh.com and login through your Moneysukh User ID & password.</li>
                      <li>Search for the security you want to trade in. </li>
                      <li>You must ensure that you have sufficient funds to trade in that security</li>
                      <li>Hover over the security and Tap on buy/sell. Fill in the necessary details like price, quantity, etc.</li>
                      <li>Conclude the transaction</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Q4. What are the charges for trading in F&O segment?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                    You can check the charges for trading in F&O segment from .
                      <a href="/Pricing" target="_blank">here</a>.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>Q5. What is span margin?</Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      Exchanges use Standard Portfolio Analysis of Risk (SPAN)
                      to calculate risk and margins for F&O portfolios. SPAN
                      margin is monitored and collected when an order is placed,
                      and it is updated by the exchanges throughout the day. The
                      writers require a considerable margin in order for their
                      losses to be covered. The SPAN system calculates the
                      one-day move based on the worst-case scenario, and as a
                      result, the margin is set for each and every position.
                      SPAN calculates the maximum possible loss for a portfolio
                      based on the price and volatility of the underlying
                      security, as well as several other variables. SPAN margins
                      differ from security to security depending on the type of
                      risk that must be accepted along with the security.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
            <Col md={4}>
              <div className="faq-beta">
                <img className="img-fluid" src={AskFaq} alt={AskFaq} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default FnOFaq;
